import cn from 'classnames';
import type { FC } from 'react';
import Modal from 'react-modal';
import * as st from './ModalMiddle.module.scss';

interface Props {
  isOpen: boolean;
  children?: React.ReactNode;
  close?: () => void;
  onRequestClose?: () => void;
  info?: string;
  title?: string;
  className?: string;
  overlayClassName?: string;
  showClose?: boolean;
}

Modal.setAppElement('#root');

const ModalMiddle: FC<Props> = ({
  isOpen,
  children,
  onRequestClose,
  className,
  overlayClassName,
}) => {
  const onAfterOpen = () => {
    document.body.style.overflow = 'hidden';
  };

  const onAfterClose = () => {
    document.body.style.overflow = 'auto';
  };

  return (
    <Modal
      onAfterOpen={onAfterOpen}
      onAfterClose={onAfterClose}
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      className={cn(st.modal, className)}
      overlayClassName={cn(st.overlay, overlayClassName)}
    >
      {children}
    </Modal>
  );
};

export default ModalMiddle;
